import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=ab0dd14e&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=ab0dd14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0dd14e",
  null
  
)

export default component.exports